/* eslint-disable no-nested-ternary */
/* eslint-disable indent */
/* eslint-disable */
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery'
import isValid from 'is-valid-path'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { bpmnRefreshTypes } from '../../../../constants'
import { setCurrentFlowGroup } from '../../../../actions'
import { Logger, LoggerTypes } from '../../../../utils'
import { Bpmn, BpmnModeler } from '../Bpmn'
import { Map } from '../Map'
import './style.scss'

// let loadNum = 0

export const FlowTab = forwardRef(({ flowGroup, onSave, onSimulationList, onSimulationLaunch }, ref) => {
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()
  // -- get the selected BPMN element to be able to reselect it after saving
  const flowGroups = useSelector((state) => state.flowGroups)
  const currentElement = useSelector((state) => state.flowGroupElements)

  const [diagram, setDiagram] = useState({
    data: flowGroup.xml,
    isLoading: true,
    bpmnModeler: null
  })
  // const isXmlPath = isValid(diagram.data)
  const id = (flowGroup && flowGroup.id) || 0
  const dispatch = useDispatch()

  const flowGroupTasks = flowGroups?.flowGroupTasks || null

  // -- initialize BPMN XML content in the HTML Dom
  useEffect(async () => {
    Logger.trace(LoggerTypes.CONTAINER, 'FlowTab.useEffect()', { el: $(`#bpmn-${id}`).length, diagram })

    if ($(`#bpmn-${id}`).length > 0) {
      try {
        const bpmnModeler = new BpmnModeler({ container: $(`#bpmn-${id}`) }, dispatch)
        const xml = await bpmnModeler.importXML(diagram.data)
        const { warnings } = xml

        if (xml && warnings && warnings.length > 0) {
          Logger.trace(LoggerTypes.WARN, 'FlowTab.useEffect().importXML()', { xml })
        } else {
          // Why we load the XML twice ?
          // if (isXmlPath) {
          //   xml = res.data
          //   await bpmnModeler.importXML(xml)
          //   Logger.trace(LoggerTypes.CONTROLLER, 'FlowTab.useEffect().importXML(PATH)', { xml })
          // } else {
          //   xml = diagram.data
          //   Logger.trace(LoggerTypes.CONTROLLER, 'FlowTab.useEffect().importXML(XML)', { xml })
          // }
          Logger.trace(LoggerTypes.CONTROLLER, 'FlowTab.useEffect().setViewbox()', {
            xml: diagram.data,
            warnings
          })
          bpmnModeler.setViewbox(
            flowGroup.canvas_height,
            flowGroup.canvas_width,
            flowGroup.canvas_scale,
            flowGroup.canvas_x,
            flowGroup.canvas_y
          )

          // TODO: Is this really needed?
          setDiagram({
            data: flowGroup.xml,
            isLoading: false,
            bpmnModeler
          })

          // if (loadNum >= 1) {
          //   $('.bjs-container:last-child').remove()
          // }

          // bpmnModeler.get('modeling').setColor('CalmCustomerTask', {
          //   stroke: 'green',
          //   fill: 'yellow'
          // })
        }
        // loadNum++
      } catch (error) {
        Logger.trace(LoggerTypes.WARN, 'FlowTab.useEffect().importXML().catch()', {
          error,
          message: error.message,
          warnings: error.warnings
        })
      }
    }
  }, [])

  const refreshFlowGroupXML = async (bpmnRefresh, onComplete) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'FlowTab.useImperativeHandle().refreshFlowGroupXML()', {
      ref,
      diagram,
      flowGroup,
      bpmnRefresh
    })

    if (diagram.bpmnModeler && bpmnRefresh?.flowGroup) {
      Logger.trace(LoggerTypes.CONTROLLER, 'FlowTab.useImperativeHandle().refreshFlowGroupXML() OK', {
        currentElement,
        onComplete
      })

      // Import the XML in the BPMN designer. The bpmnRefresh object must match the below structure:
      // {
      //  type: FLOW_GROUP,
      //  flowGroup: The flowGroup object which contains an xml attribute string
      // }
      try {
        const xml = await diagram.bpmnModeler.importXML(bpmnRefresh.flowGroup.xml)
        const { warnings } = xml

        if (xml && warnings && warnings.length > 0) {
          Logger.trace(LoggerTypes.WARN, 'FlowTab.refreshFlowGroupXML()', { xml, warnings })
        } else {
          Logger.trace(LoggerTypes.CONTROLLER, 'FlowTab.refreshFlowGroupXML().setViewbox()', {
            flowGroup: bpmnRefresh.flowGroup,
            warnings
          })
          diagram.bpmnModeler.setViewbox(
            bpmnRefresh.flowGroup.canvas_height,
            bpmnRefresh.flowGroup.canvas_width,
            bpmnRefresh.flowGroup.canvas_scale,
            bpmnRefresh.flowGroup.canvas_x,
            bpmnRefresh.flowGroup.canvas_y
          )
        }
      } catch (error) {
        Logger.trace(LoggerTypes.WARN, 'FlowTab.useEffect().importXML().catch()', {
          error,
          message: error.message,
          warnings: error.warnings
        })
      }

      // -- Select the current element
      if (currentElement && currentElement.elementId) {
        setTimeout(() => {
          // diagram.bpmnModeler.selectElement(currentElement.elementId, currentElement.type)
          $(`[data-element-id="${currentElement.elementId}"]`).addClass('selected')
        }, 100)
      }

      if (typeof onComplete === 'function') {
        onComplete()
      }
      enqueueSnackbar(t('common.api_edit_success'), {
        variant: 'success',
        anchorOrigin: { vertical: 'bottom', horizontal: 'center' }
      })
    }
  }

  const refreshElementsProperties = async (bpmnRefresh, onComplete) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'FlowTab.refreshElementProperties()', {
      ref,
      diagram,
      flowGroup,
      bpmnRefresh
    })
    if (diagram.bpmnModeler && bpmnRefresh?.elements) {
      // Create a list of BPMN element properties to update.
      // The bpmnRefresh object must match the below structure:
      // {
      //  type: ELEMENTS,
      //  elements: [ List of actions (Flow, Condition or TaskInstance) ]
      // }
      const elements = []
      bpmnRefresh.elements?.forEach((el) => {
        // Initialize the list of elements with their new name
        const element_id = el.element_id || el?.startAction?.element_id
        const element_name = el?.task ? el.task.name : el?.startAction ? `${el.name} START` : el.name
        elements.push({
          element_id,
          properties: { name: element_name }
        })

        // If the current element is a condition, check if exists an 'inverted=true' attribute which indicates
        // that its outgoing connections names must be inverted.
        // Conditions only
        if (element_id.startsWith('Gateway')) {
          const condition = diagram.bpmnModeler.getElement(element_id)
          const connections = condition?.outgoing || []
          if (connections.length === 2) {
            const first = connections[0]
            const second = connections[1]
            const trueConnection = first.businessObject.name.startsWith('TRUE')
              ? first
              : second.businessObject.name.startsWith('TRUE')
              ? second
              : null
            const falseConnection = first.businessObject.name.startsWith('FALSE')
              ? first
              : second.businessObject.name.startsWith('FALSE')
              ? second
              : null
            const trueLabel = el?.next_action_true_is_wait ? 'TRUE WAIT' : 'TRUE'
            const falseLabel = el?.next_action_false_is_wait ? 'FALSE WAIT' : 'FALSE'

            if (el?.inverted) {
              elements.push({ element_id: trueConnection.id, properties: { name: falseLabel } })
              elements.push({ element_id: falseConnection.id, properties: { name: trueLabel } })
            } else {
              elements.push({ element_id: trueConnection.id, properties: { name: trueLabel } })
              elements.push({ element_id: falseConnection.id, properties: { name: falseLabel } })
            }
          } else {
            const message = `Could not invert connections on condition ${element_id},${connections.length} outputs found, 2 are required.`
            Logger.trace(LoggerTypes.WARN, 'FlowTab.refreshElementProperties().invertCondition()', message)
          }
        } else if (el?.task) {
          // If the current element is a taskInstance, the related task can contain other instances,
          // so we need to get all of them to updated all BPMN activities in one go.
          const taskObject = flowGroupTasks.get(flowGroup.id).tasks.get(el.task.id)
          taskObject.instances.forEach((instance) => {
            // Prevent from adding twice the task instance
            if (instance.id !== el.id) {
              elements.push({
                element_id: instance.element_id,
                properties: { name: element_name }
              })
            }
          })
        }
      })

      // Update all BPMN elements at once
      elements.forEach((el) => {
        diagram.bpmnModeler.updateElementProperties(el.element_id, el.properties)
      })

      // Now the XML has been updated in the designer, we need to update the REDUX state.
      // The XML in the flowGroup is already updated in the back-end. This operation is here
      // to prevent from loading again the XML from the back-end for performance reasons.
      const { xml } = (await diagram.bpmnModeler.getXML()) || null
      const updatedFlowGroup = {
        ...flowGroup,
        xml: xml
      }
      // We override here the flowGroup in the cache with the new XML data to make sure that
      // the next state (ie: tonTabChange) will get the lastest BPMN updates to refresh
      dispatch(setCurrentFlowGroup(updatedFlowGroup))

      // -- Select the current element
      if (currentElement?.elementId) {
        setTimeout(() => {
          // diagram.bpmnModeler.selectElement(currentElement.elementId, currentElement.type)
          $(`[data-element-id="${currentElement.elementId}"]`).addClass('selected')
        }, 100)
      }

      if (onComplete && typeof onComplete === 'function') {
        onComplete()
      }
    }
  }

  // This handler is called when the designer's save button is pressed and by all save buttons of the FlowElements
  useImperativeHandle(ref, () => ({
    refreshBpmn(bpmnRefresh, onComplete) {
      Logger.trace(LoggerTypes.CONTROLLER, 'FlowTab.useImperativeHandle().refreshBpmn()', {
        bpmnRefresh,
        onComplete
      })

      if (bpmnRefresh?.type === bpmnRefreshTypes.ELEMENTS) {
        // Refresh the BPMN element properties
        refreshElementsProperties(bpmnRefresh, onComplete)
      } else if (bpmnRefresh?.type === bpmnRefreshTypes.FLOW_GROUP) {
        // Refresh the FlowGroup XML
        refreshFlowGroupXML(bpmnRefresh, onComplete)
      } else {
        Logger.trace(LoggerTypes.CONTROLLER, 'FlowTab.useImperativeHandle().refreshBpmn() - ERROR', {
          bpmnRefresh,
          onComplete
        })
      }
    }
  }))

  // This method is called when the FlowElementTaskAboutPanel is saved
  // useImperativeHandle(ref, () => ({
  //   refreshElementProperties(_updateAction, onComplete) {
  //     Logger.trace(LoggerTypes.CONTROLLER, 'FlowTab.useImperativeHandle().refreshElementProperties()', {
  //       ref,
  //       _updateAction,
  //       bpmnModeler: diagram.bpmnModeler,
  //       data: diagram.data
  //     })
  //     if (diagram.bpmnModeler && diagram.data && flowGroup.xml) {
  //       Logger.trace(LoggerTypes.CONTAINER, 'FlowTab.useImperativeHandle().refreshElementProperties() OK', {
  //         currentElement,
  //         onComplete
  //       })

  //       // Update the name of the action (Condition or TaskInstance)
  //       diagram.bpmnModeler.updateElementProperties(_updateAction.element_id, {
  //         name: _updateAction?.task?.name || _updateAction?.name
  //       })

  //       // -- Select the current element
  //       if (currentElement && currentElement.elementId) {
  //         setTimeout(() => {
  //           // diagram.bpmnModeler.selectElement(currentElement.elementId, currentElement.type)
  //           $(`[data-element-id="${currentElement.elementId}"]`).addClass('selected')
  //         }, 100)
  //       }

  //       if (typeof onComplete === 'function') {
  //         onComplete()
  //       }
  //     }
  //   }
  // }))

  // Logger.trace(LoggerTypes.CONTAINER, 'FlowTab.render()', { isXmlPath, flowGroup, diagram })

  return (
    <div className="FlowTab">
      <Bpmn id={id} />
      {diagram.bpmnModeler && (
        <Map
          modeler={diagram.bpmnModeler}
          flowGroup={flowGroup}
          onSave={onSave}
          onSimulationList={onSimulationList}
          onSimulationLaunch={onSimulationLaunch}
        />
      )}
    </div>
  )
})

FlowTab.displayName = 'FlowTab'

FlowTab.propTypes = {
  flowGroup: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  onSimulationList: PropTypes.func.isRequired,
  onSimulationLaunch: PropTypes.func.isRequired
}

FlowTab.defaultProps = {
  flowGroup: {},
  onSave: () => {},
  onSimulationList: () => {},
  onSimulationLaunch: () => {}
}
